"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.p11n = void 0;
function p11n(testNumber, pluralString) {
    const tuple = pluralString.split(`~`);
    const form = tuple[0];
    if (form === '1') {
        const formIf1 = tuple[1];
        const everythingElse = tuple[2];
        if (testNumber === 1)
            return formIf1;
        return everythingElse;
    }
    if (form === '2') {
        const formIf0or1 = tuple[1];
        const everythingElse = tuple[2];
        if (testNumber === 0 || testNumber === 1)
            return formIf0or1;
        return everythingElse;
    }
    console.log(`Incorrect usage of p11n: incorrect form of string ${pluralString}`);
    return tuple[2] || '';
}
exports.p11n = p11n;
